<script>
  import { onMount } from 'svelte';
  import { restoreLocation } from '../stores/currentLocation';

  onMount(restoreLocation);
</script>
